import { Modality } from '@/store/modules/course/state';

// Mesma lógica do `selectedCityStorage`: a modalidade só existe no store, que nasce vazio
// a cada reload, e o candidato que escolheu SEMI voltaria a ver os polos de EAD.
const SELECTED_MODALITY_KEY = 'admissions-selected-modality';

interface StoredSelectedModality {
  admissionId?: number;
  modality: Modality;
}

export function saveSelectedModality(modality: Modality, admissionId?: number): void {
  try {
    const record: StoredSelectedModality = { admissionId, modality };

    window.sessionStorage.setItem(SELECTED_MODALITY_KEY, JSON.stringify(record));
  } catch {
    // storage bloqueado degrada para EAD, que é o comportamento anterior.
  }
}

export function readSelectedModality(admissionId?: number): Modality | undefined {
  try {
    const raw = window.sessionStorage.getItem(SELECTED_MODALITY_KEY);

    if (!raw) return undefined;

    const record: StoredSelectedModality = JSON.parse(raw);

    if (record?.admissionId !== admissionId) return undefined;

    return record.modality === 'SEMI' || record.modality === 'EAD' ? record.modality : undefined;
  } catch {
    return undefined;
  }
}
